import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const statistiquesJusticeData = [
     {
    ministere: 'Ministère de la Justice',
    annuaires: 'ANNUAIRE DES STATISTIQUES JUDICIAIRES EDITION 2023',
    description: 'Un rapport complet sur les statistiques judiciaires, fournissant des données clés sur les performances du système judiciaire et l’accès à la justice pour l’année 2023.',
    date: "2024-12-31",
    link: "/documents/Sectorials/ANNUAIRE_DES_STATISTIQUES_JUDICIAIRES_2023.pdf" 
  },
    {
    ministere: 'Ministère de la Justice',
    annuaires: 'ANNUAIRE DES STATISTIQUES JUDICIAIRES EDITION 2022',
    description: 'Un rapport complet sur les statistiques judiciaires, fournissant des données clés sur les performances du système judiciaire et l’accès à la justice pour l’année 2022.',
    date: "2023-12-31",
    link: "/documents/Sectorials/ANNUAIRE_DES_STAT_Jud_Ed_2022.pdf" 
  },
    {
    ministere: 'Ministère de la Justice',
    annuaires: 'ANNUAIRE DES STATISTIQUES JUDICIAIRES EDITION 2021',
    description: 'Un rapport complet sur les statistiques judiciaires, fournissant des données clés sur les performances du système judiciaire et l’accès à la justice pour l’année 2021.',
    date: "2022-12-31",
    link: "/documents/Sectorials/ANNUAIRE_DES_STAT_Jud_Ed_2021.pdf" 
  },
  {
    ministere: 'Ministère de la Justice',
    annuaires: 'ANNUAIRE STATISTIQUE EDITION 2019-2020',
    description: 'Un rapport détaillé sur les statistiques judiciaires, offrant une analyse approfondie des tendances et des performances du système judiciaire au cours de l\'année 2019-2020.',
    date: "2021-12-31",
    link: "/documents/Sectorials/ANNUAIRE_ DES STAT_Jud_Ed_2019_2020.pdf" 
  },
  {
    ministere: 'Ministère de la Justice',
    annuaires: 'ANNUAIRE DES STATISTIQUES JUDICIAIRES EDITION 2017-2018',
    description: 'Un rapport exhaustif sur les performances du système judiciaire, y compris des données sur le traitement des affaires et l’accès à la justice.',
    date: "2018-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-2017-2018.pdf" 
  },
  {
    ministere: 'Ministère de la Justice',
    annuaires: 'ANNUAIRE DES STATISTIQUES JUDICIAIRES EDITION 2015-2016',
    description: 'Les indicateurs statistiques clés du secteur judiciaire durant les années 2015 et 2016, servant d’outil d\'évaluation des mesures prises pour renforcer la justice.',
    date: "2016-12-31",
    link: "/documents/Sectorials/Annuaire-des-statistiques-judiciaires-2015-2016.pdf" 
  }
];

function MinistereJustice() {
  const [visibleCount, setVisibleCount] = useState(4); 
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredStatistiques, setFilteredStatistiques] = useState([]);

  useEffect(() => {
    const sortedData = statistiquesJusticeData.sort((a, b) => new Date(b.date) - new Date(a.date));
    setFilteredStatistiques(sortedData);
  }, []);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 1, filteredStatistiques.length)); 
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredStatistiques(statistiquesJusticeData.sort((a, b) => new Date(b.date) - new Date(a.date)));
    } else {
      const filtered = statistiquesJusticeData.filter((statistique) => {
        const statistiqueYear = new Date(statistique.date).getFullYear();
        return statistiqueYear === parseInt(year);
      });
      setFilteredStatistiques(filtered.sort((a, b) => new Date(b.date) - new Date(a.date)));
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
           Ministère de la Justice, des Droits de la Personne Humaine et du Genre
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Ministère de la Justice est responsable de la mise en œuvre et du suivi des réformes dans le système judiciaire. Ces rapports fournissent des informations essentielles sur les indicateurs de performance et l'accès à la justice.
          </Typography>
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de réalisation</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de réalisation"
            >
              <MenuItem value="Tous">Tous les annuaires</MenuItem>
              {[...new Set(statistiquesJusticeData.map((statistique) => new Date(statistique.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '5px' }}>
            {filteredStatistiques.slice(0, visibleCount).map((statistique, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={statistique.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={"assets/annuaires/minijust.png"} 
                        alt={statistique.annuaires}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={statistique.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{statistique.annuaires}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {statistique.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(statistique.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredStatistiques.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereJustice;